import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//

import ArtistAvatar from '@/components/home/ArtistAvatar';
import Drip from 'drip';
export default {
  name: 'artist-list',
  components: {
    ArtistAvatar: ArtistAvatar
  },
  props: {
    list: {
      type: Array,
      default: []
    }
    // isAbTest:{
    //   type: Boolean,
    //   default: false,
    // }
  },

  data: function data() {
    return {};
  },
  methods: {
    handleItemClick: function handleItemClick(content) {
      var _ref = content || {},
        jumpUrl = _ref.jumpUrl,
        dataSeed = _ref.dataSeed,
        tagSeed = _ref.tagSeed;
      if (!jumpUrl) return;
      if (tagSeed) {
        window.lxTagReport('c_movie_aq5xt2v5', dataSeed.bid, Object.assign({}, tagSeed));
      }
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
      this.go(jumpUrl, {
        _blank: true
      });
    }
  }
};